var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBasics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.109 -0.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.244,12.288a.779.779,0,0,0,.776-.781V3.01A2.339,2.339,0,0,0,30.691.667H2.438A2.339,2.339,0,0,0,.109,3.01V38.323a2.339,2.339,0,0,0,2.329,2.344H30.691a2.339,2.339,0,0,0,2.329-2.344V32.567a.776.776,0,1,0-1.552,0v5.756a.78.78,0,0,1-.776.781H2.438a.78.78,0,0,1-.776-.781V3.01a.78.78,0,0,1,.776-.781H30.691a.78.78,0,0,1,.776.781v8.5A.779.779,0,0,0,32.244,12.288Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.02,8.542a7.407,7.407,0,0,0-5.084,12.8.8.8,0,0,0,.087.081,7.4,7.4,0,0,0,10,0,.8.8,0,0,0,.087-.081,7.407,7.407,0,0,0-5.084-12.8Zm0,13.211a5.769,5.769,0,0,1-3.5-1.182,4.028,4.028,0,0,1,7.007,0A5.769,5.769,0,0,1,25.02,21.753ZM23.731,15.63v-.524a1.289,1.289,0,0,1,2.578,0v.524a1.289,1.289,0,0,1-2.578,0Zm5.956,3.76A5.588,5.588,0,0,0,27.314,17.4a2.885,2.885,0,0,0,.606-1.771v-.524a2.9,2.9,0,0,0-5.8,0v.524a2.885,2.885,0,0,0,.606,1.771,5.588,5.588,0,0,0-2.373,1.989,5.8,5.8,0,1,1,9.335,0Z",
    transform: "translate(-8.289 -3.525)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.726,64.542h-4.35a.806.806,0,0,0,0,1.611h4.35a.806.806,0,1,0,0-1.611Z",
    transform: "translate(-13.761 -29.836)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.979,56.375H17.54a.806.806,0,0,0,0,1.611H28.979a.806.806,0,1,0,0-1.611Z",
    transform: "translate(-7.847 -25.902)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.979,48.208H17.54a.806.806,0,1,0,0,1.611H28.979a.806.806,0,1,0,0-1.611Z",
    transform: "translate(-7.847 -22.105)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.884,40.278a.805.805,0,1,0,.236.57A.812.812,0,0,0,11.884,40.278Z",
    transform: "translate(-4.655 -18.308)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.884,48.444a.8.8,0,1,0,.236.569A.813.813,0,0,0,11.884,48.444Z",
    transform: "translate(-4.655 -22.105)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.884,56.611a.805.805,0,1,0,.236.569A.813.813,0,0,0,11.884,56.611Z",
    transform: "translate(-4.655 -25.902)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.979,40.042H17.54a.806.806,0,0,0,0,1.611H28.979a.806.806,0,1,0,0-1.611Z",
    transform: "translate(-7.847 -18.308)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.09,19.3a3.383,3.383,0,0,0-4.622,1.238L44.331,38.1a.807.807,0,0,0-.1.313L43.515,44.8a.806.806,0,0,0,1.278.738l5.178-3.814a.8.8,0,0,0,.22-.246L60.328,23.925A3.387,3.387,0,0,0,59.09,19.3ZM45.32,43.153l.373-3.338,2.331,1.346ZM49.2,39.98l-3.07-1.772,8.135-14.09,3.07,1.772Zm9.734-16.86-.794,1.375L55.07,22.722l.794-1.375a1.772,1.772,0,0,1,3.07,1.772Z",
    transform: "translate(-20.672 -9.382)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasics);
export default __webpack_public_path__ + "static/media/icon_basics.589924f94acdf86e7cc8396987dc7018.svg";
export { ForwardRef as ReactComponent };